import React from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import Scene from '../Scene';
import { FOOTER_CONTENT } from "../../constants/index.js";

const FooterBox = styled(Scene)`
  box-sizing: border-box;
  padding: 16px 38px;
  background-color: #757575;
  color: white;
  font-size: 12px;
  text-align: left;
  ${breakpoint("md")`
    padding: 24px 24px 20px 24px;
    font-size: 14px;
  `}
`;

const Footer = () => {
  return <FooterBox>{FOOTER_CONTENT}</FooterBox>;
};

export default Footer;
